import en from './en.json';
import it from './it.json';
import fr from './fr.json';
import es from './es.json';
import de from './de.json';

export const translations = {
  en,
  it,
  fr,
  es,
  de
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

// Track missing translations in development
const missingTranslations = new Set();

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang];
  let fallbackUsed = false;
  
  // Try to get the value for the requested language
  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      fallbackUsed = true;
      break;
    }
  }
  
  // If not found in requested language, try English fallback
  if (fallbackUsed) {
    result = translations.en;
    for (const k of keys) {
      if (result && result[k] !== undefined) {
        result = result[k];
      } else {
        // Key doesn't exist even in English - log warning
        const missingKey = `${lang}:${key}`;
        if (!missingTranslations.has(missingKey)) {
          missingTranslations.add(missingKey);
          console.warn(`[i18n] MISSING TRANSLATION: "${key}" for language "${lang}"`);
        }
        return `[${key}]`; // Return key wrapped in brackets to make it visible
      }
    }
    
    // Log that we used English fallback
    if (process.env.NODE_ENV === 'development') {
      const fallbackKey = `fallback:${lang}:${key}`;
      if (!missingTranslations.has(fallbackKey)) {
        missingTranslations.add(fallbackKey);
        console.warn(`[i18n] Using English fallback for "${key}" in "${lang}"`);
      }
    }
  }
  
  return result;
};

// Export function to check all translations at build time
export const validateTranslations = () => {
  const getAllKeys = (obj, prefix = '') => {
    const keys = [];
    for (const k of Object.keys(obj)) {
      const fullKey = prefix ? `${prefix}.${k}` : k;
      if (typeof obj[k] === 'object' && obj[k] !== null) {
        keys.push(...getAllKeys(obj[k], fullKey));
      } else {
        keys.push(fullKey);
      }
    }
    return keys;
  };
  
  const enKeys = new Set(getAllKeys(en));
  const issues = [];
  
  for (const [langCode, langData] of Object.entries(translations)) {
    if (langCode === 'en') continue;
    const langKeys = new Set(getAllKeys(langData));
    
    // Find missing keys
    for (const key of enKeys) {
      if (!langKeys.has(key)) {
        issues.push(`Missing in ${langCode.toUpperCase()}: ${key}`);
      }
    }
  }
  
  if (issues.length > 0) {
    console.warn('[i18n] Translation validation issues:');
    issues.forEach(issue => console.warn(`  - ${issue}`));
  }
  
  return issues;
};

export default translations;
